import { defineStore } from 'pinia'
import { ref } from 'vue'
import { i18n } from '@/i18n'

const DEFAULT_DURATION_MS = 6000

export const useNotificationCardsStore = defineStore('notificationCards', () => {
  const cards = ref([])
  const timers = new Map()

  /**
   * @param {object} payload
   * @param {string} [payload.title]
   * @param {string} [payload.message]
   * @param {string} [payload.image] - miniatura (póster); si falta se pinta el icono
   * @param {string} [payload.icon] - icono cuando no hay imagen
   * @param {object|null} [payload.actionRoute] - null explícito = tarjeta sin botón
   * @param {string} [payload.actionText]
   * @param {number} [payload.duration] - 0 o menos = no se cierra sola
   */
  function add(payload) {
    const id = `nc-${Date.now()}-${Math.random().toString(36).slice(2, 9)}`
    const card = {
      id,
      title: payload.title ?? i18n.global.t('notificationsPage.new_notification'),
      message: payload.message ?? '',
      image: payload.image || null,
      icon: payload.icon || 'mdi-bell-ring-outline',
      // `in` y no `??`: así un null explícito significa "sin botón" y no
      // acaba mandando al usuario al buzón de notificaciones.
      actionRoute: 'actionRoute' in payload ? payload.actionRoute : { name: 'notifications' },
      actionText: payload.actionText ?? i18n.global.t('notificationsPage.view'),
      createdAt: Date.now(),
    }
    cards.value = [card, ...cards.value]

    const duration = payload.duration ?? DEFAULT_DURATION_MS
    if (duration > 0) {
      const timer = setTimeout(() => {
        remove(id)
        timers.delete(id)
      }, duration)
      timers.set(id, timer)
    }

    return id
  }

  function remove(id) {
    cards.value = cards.value.filter((c) => c.id !== id)
    const timer = timers.get(id)
    if (timer) {
      clearTimeout(timer)
      timers.delete(id)
    }
  }

  function clear() {
    cards.value = []
    timers.forEach((t) => clearTimeout(t))
    timers.clear()
  }

  return {
    cards,
    add,
    remove,
    clear,
  }
})
